import React, { useState, useRef, useCallback } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import { ShoppingLists } from '../components/trip/ShoppingLists';
import { useTrip } from '../contexts/TripContext';
import { useLanguage } from '../contexts/LanguageContext';
import { PageHeader } from '../components/common/PageHeader';
import { Button } from '../components/ui/button';
import { Plus } from 'lucide-react';

export default function TripShoppingLists() {
  const { tripId } = useParams();
  const context = useOutletContext();
  const { trip, isOrganizer } = context || {};
  const { members } = useTrip();
  const { t } = useLanguage();
  const openDialogRef = useRef(null);

  const handleOpenDialog = useCallback((openFn) => {
    openDialogRef.current = openFn;
  }, []);

  return (
    <div className="space-y-6">
      <PageHeader
        title={t('shopping.title')}
        subtitle={t('shopping.subtitle')}
        helpScreen="shopping"
        actions={
          <Button 
            className="rounded-full bg-orange-500 hover:bg-orange-600" 
            data-testid="create-shopping-list-btn"
            onClick={() => openDialogRef.current?.()}
          >
            <Plus className="w-4 h-4 mr-2" />
            <span className="hidden sm:inline">{t('shopping.newList')}</span>
            <span className="sm:hidden">{t('common.add')}</span>
          </Button>
        }
      />
      <ShoppingLists 
        tripId={tripId} 
        members={members}
        isOrganizer={isOrganizer}
        hideHeader={true}
        onOpenDialog={handleOpenDialog}
      />
    </div>
  );
}
